import { render, staticRenderFns } from "./LiveTimestamp.vue?vue&type=template&id=3d938354&"
import script from "./LiveTimestamp.vue?vue&type=script&lang=js&"
export * from "./LiveTimestamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports